import { Model } from '@vuex-orm/core'

export default class Connection extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'connections'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      integration: this.attr(null),
      status: this.attr(null),
      status_detail: this.attr(null),
      name: this.attr(null),
      provider_unique_id: this.attr(null),
      settings: this.attr(null),
      connection_config: this.attr(null),
      metadata: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Connection.js